import { defineStore } from 'pinia';

const ngAdapterStore = defineStore('ngAdapterStore', {
    state: () => ({
        ngStores: {},
        initialized: false,
    }),
    actions: {
        async initNgStores() {
            let updateVueStore = (key, value) => {
                this.updateVueStore(key, value);
            };
            return new Promise((resolve) => {
                let storeInitCheck = setInterval(() => {
                    if (document.getElementById('vue_services_container')) {
                        if (typeof $ !== 'function') return;
                        let getFetchTimePaths = (storePart, fullPath, outputKeys) => {
                            // returns an array of fetchTime dot-notation paths eg:
                            // [
                            //    'userStore.activeUser.profile.fetchTime',
                            //    'userStore.loggedUsers.vol.profile.fetchTime',
                            //    'userStore.loggedUsers.vol.records.opp.fetchTime',
                            //    'recordStore.opp.fetchTime'
                            // ]
                            if (!outputKeys) outputKeys = [];
                            Object.keys(storePart).forEach(function (key) {
                                let iPath = fullPath;
                                if (!iPath) iPath = key;
                                else iPath += '.' + key;
                                // Iterate of sub-object
                                if (storePart[key] !== null && typeof storePart[key] === 'object') {
                                    // Check our storePart to see if it has NG's fetchTime keys
                                    getFetchTimePaths(storePart[key], iPath, outputKeys);
                                    return;
                                }
                                if (key === 'fetchTime') {
                                    outputKeys.push(iPath);
                                }
                            });
                            return outputKeys;
                        };
                        let ngStores = $("#vue_services_container").scope();
                        this.ngStores = ngStores;
                        let storeKeys = Object.keys(this.ngStores);
                        storeKeys.forEach((key) => {
                            if (key.indexOf('$') !== -1) return; // only process non-ng-reserved keys
                            let fetchTimeKeys = getFetchTimePaths(ngStores[key], key);
                            let matchingFtKeys = fetchTimeKeys.filter((ftKey) => ftKey.indexOf(key) === 0);
                            // Process store objects with fetchTime
                            if (Array.isArray(matchingFtKeys) && matchingFtKeys.length) {
                                matchingFtKeys.forEach((fKey) => {
                                    let storeKey = fKey.replace('.fetchTime', '');
                                    ngStores.$watch(fKey, function () {
                                        let newVal = library.getByPath(ngStores, storeKey);
                                        updateVueStore(storeKey, newVal);
                                    });
                                });
                            }
                            // Process store objects that are arrays (forms)
                            else if (key === 'forms') {
                                ngStores.$watch(key, function (newVal) {
                                    updateVueStore(key, newVal);
                                }, true); // deep
                            }
                            else if (Array.isArray(ngStores[key])) {
                                ngStores.$watchCollection(key, function (newVal) {
                                    updateVueStore(key, newVal);
                                });
                            }
                            // Process everything else
                            else {
                                ngStores.$watch(key, function (newVal) {
                                    updateVueStore(key, newVal);
                                });
                            }
                        });
                        this.initialized = true;
                        clearInterval(storeInitCheck);
                        resolve();
                    }
                }, 100, 50); // NOSONAR
            });
        },
        updateVueStore(key, value) {
            if (key.indexOf('.') !== -1) library.setByPath(this.ngStores, key, value);
            // else if (Array.isArray(value)) this.ngStores[key] = [...value];
            // else if (typeof value === 'object') this.ngStores[key] = { ...value };
            // TODO figure out if there's a better way to merge changes
            else if (key === 'forms') this.ngStores[key] = { ...value };
            // TODO verify this doesn't cause problems with stores
            else this.ngStores[key] = value;
        },
        updateNgStore(value) {
            if (
                typeof this.ngStores !== 'object'
                || typeof this.ngStores.$apply !== 'function'
            ) return;
            this.ngStores.$apply(() => {
                this.ngStores = value;
            });
        }
    }
});

export { ngAdapterStore };
